let px2em = function (pixels) {
  px2em = implementation(
    parseFloat(getComputedStyle(document.documentElement).fontSize),
  );
  return px2em(pixels);
};
let px2rem = function (pixels) {
  px2rem = implementation(
    parseFloat(getComputedStyle(document.documentElement).fontSize),
    'rem'
  );
  return px2rem(pixels);
};

export { px2em, px2rem };

function implementation(rootEm, unit = 'em') {
  // console.log('single run', rootEm)
  return (pixels) => {
    let result = isNaN(pixels) ? pixels : `${pixels / rootEm}${unit}`;
    // console.log(`px2em: ${pixels} => ${result}`);
    return result;
  };
}
